<template>
	<div class="ui-slider">
		<div class="button minus" v-hammer:tap="() => set_value(local_value - 1)">-</div>
		<div class="bars" :class="slug">
			<div v-for="i in max" :key="i" class="bar" :class="{ full: i <= local_value }">I</div>
			<div class="bars-over" ref="bars" v-hammer:pan="pan" v-hammer:tap="pan"></div>
		</div>
		<div class="button plus" v-hammer:tap="() => set_value(local_value + 1)">+</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'ui-slider',
	data() {
		return {
			local_value: null
		}
	},
	props: {
		value: { default: 5 },
		min: { default: 0 },
		max: { default: 10 },
		slug: { default: 1 }
	},
	computed: {
		...mapGetters([ 'app' ])
	},
	watch: {
		local_value() {
			if (this.local_value !== this.value) {
				this.$emit('change', { slug: this.slug, value: this.local_value })
			}
		}
	},
	methods: {
		pan(e) {
			const rect = this.$refs.bars.getBoundingClientRect()
			const diff = (e.center.x / this.app.zoom - rect.x)
			this.set_value(Math.ceil(diff / (rect.width / this.max)))
		},
		set_value(value) {
			if (value < this.min) value = this.min
			if (value > this.max) value = this.max
			this.local_value = value
		}
	},
	created() {
		this.local_value = this.value
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.ui-slider
	height 100%
	flex center center
	.button
		height 100%
		width 40px
		height 32px
		font-size 3.2rem
		line-height @height
		text-align center
		&:active
			transform translateY(2px)
	.bars
		height 100%
		flex flex-start flex-start
		padding-top 2px
		&.musics .bar
			for i in 1..20
				&:nth-child({i})
					transform 'translateY(%spx) rotate(%sdeg)' % ( random(-1, 1) random(-6, 6) )
		&.sounds .bar
			for i in 1..20
				&:nth-child({i})
					transform 'translateY(%spx) rotate(%sdeg)' % ( random(-1, 1) random(-6, 6) )
		.bar
			width 12px
			height 100%
			font-size 4rem
			flex center center
			opacity 0.25
			&.full
				opacity 1
	.bars-over
		absolute 0
		

</style>
